import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-pension-contribution-dialog',
  templateUrl: './pension-contribution-dialog.component.html',
  styleUrls: ['./pension-contribution-dialog.component.scss']
})
export class PensionContributionDialogComponent implements OnInit {
  @Input() currentValue: number;
  @ViewChild('contributionInput') contributionInput: ElementRef;

  form: FormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      contribution: [this.currentValue, [Validators.required, Validators.min(0)]]
    });
  }

  public closeBtnClick(): void {
    this.activeModal.dismiss();
  }

  public onDelete(): void {
    this.form.patchValue({
      contribution: 0
    });
    
    this.form.markAsTouched();

    setTimeout(() => {
      this.contributionInput.nativeElement.focus();
      this.contributionInput.nativeElement.select();
      
      this.contributionInput.nativeElement.classList.add('highlight-change');
      
      setTimeout(() => {
        this.contributionInput.nativeElement.classList.remove('highlight-change');
      }, 2000);
    }, 100);
  }

  public onSave(): void {
    if (this.form.valid) {
      this.activeModal.close({
        action: 'save',
        value: Number(this.form.get('contribution').value)
      });
    }
  }

  get contributionControl() {
    return this.form.get('contribution');
  }

  hasError(error: string): boolean {
    return this.contributionControl.hasError(error) && this.contributionControl.touched;
  }
}